export enum WizardDialogTrigger {
  DATEPICKERSTART = "datePickerStart",
  DATEPICKEREND = "datePickerEnd",
  GUESTPICKER = "guestpicker",
  TYPEAHEADCLOSE = "typeaheadClose"
}
